export default "__VITE_PUBLIC_ASSET__7e7b569d__"